// extracted by mini-css-extract-plugin
export default {"faqChoiceAgentItem":"faqChoiceAgentItem_Q3geJ","description":"description_zctq4","picture":"picture_KFtFR"};